<div class="modal-overlay" (click)="onClose()">
  <!-- The .stopImmediatePropagation() prevents a click inside the modal from closing it -->
  <div class="modal-container" (click)="$event.stopImmediatePropagation()">
    <button class="close-btn" (click)="onClose()">×</button>

    <div class="modal-header">
      <div class="company_content">
        <h1 class="modal-title">
          {{ deviceMacArray.company_name }}
        </h1>
        <!-- <p class="modal-subtitle">Device Performance & Connectivity Overview</p> -->
      </div>
      <div class="filter-content">
        <div class="filter-section">
          <div class="date-filter">
            <input
              type="date"
              [(ngModel)]="startDate"
              (change)="onDateChange()"
              class="date-input"
              id="startDate">
            <span class="date-separator">to</span>
            <input
              type="date"
              [(ngModel)]="endDate"
              (change)="onDateChange()"
              class="date-input"
              id="endDate">
          </div>
          <div class="checkbox-filters">
            <label class="checkbox-label">
              <input
                type="checkbox"
                [(ngModel)]="thisMonth"
                (change)="onThisMonthChange()"
                id="thisMonth">
              <span class="checkmark"></span>
              This Month
            </label>
            <label class="checkbox-label">
              <input
                type="checkbox"
                [(ngModel)]="prevMonth"
                (change)="onPrevMonthChange()"
                id="prevMonth">
              <span class="checkmark"></span>
              Previous Month
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="summary-dashboard">
      <div class="company-info">
        <!-- <h3>Company Details</h3> -->
        <p>
          <mat-icon class="icon-industry">factory</mat-icon>
          {{ deviceMacArray.industry_type }}
        </p>
        <p>
          <mat-icon class="icon-address">location_on</mat-icon>
          {{ deviceMacArray.address }}
        </p>
        <p>
          <mat-icon class="icon-email">email</mat-icon>
          {{ deviceMacArray.email }}
        </p>
        <p>
          <mat-icon class="icon-phone">phone</mat-icon>
          {{ deviceMacArray.phone_no }}
        </p>
      </div>

      <div class="performance-summary">
        <!-- <h3>Performance Snapshot</h3> -->
         @if (isLoading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
            <p class="loading-text">Just a moment — loading your performance metrics...</p>
          </div>
        }
        @else {
          <div class="pie-chart-container">
            <ngx-charts-pie-chart [results]="pieChartData" [scheme]="{ domain: chartColors }" [gradient]="false" [labels]="true" [doughnut]="true" [animations]="false">
            </ngx-charts-pie-chart>
          </div>
        }
      </div>
    </div>
    <div class="container-max">
      @if (isLoading) {
        <div class="loading-container">
          <div class="loading-spinner"></div>
          <p class="loading-text">Just a moment — loading your device cards...</p>
        </div>
      }
      @else {
        <div class="device-card-grid fade-in" id="deviceGrid">
          @for (item of macArray?.macs; let i = $index; track item.mac_address) {
          <div class="device-card" [style.animation-delay]="i * 0.07 + 's'">
            <div class="aurora-bg"></div>

            <div class="card-header">
              <div class="header-title">
                <h3>
                  {{ item.serial_number || 'N/A' }}
                </h3>
                <span class="mac-badge">
                  {{ item.mac_address }}</span>
              </div>
              <button class="info-btn" type="button" (click)="toggleDetails(item)">
                <div class="info-icon"></div>
              </button>

            </div>

            <div class="card-body">
              <div class="primary-stat green-stat">
                <span class="stat-title">ONLINE TIME</span>
                <strong class="stat-value">
                  {{ secondsToDDHHMMSS(item.sum_online_time) }}</strong>
              </div>
              <div class="primary-stat red-stat">
                <span class="stat-title">OFFLINE TIME</span>
                <strong class="stat-value">
                  {{ secondsToDDHHMMSS(item.sum_offline_time) }}</strong>
              </div>
              <div class="primary-stat blue-stat">
                <span class="stat-title">SUMMARY FILES</span>
                <strong class="stat-value">
                  {{ item.summary_files }}</strong>
              </div>
              <div class="primary-stat orange-stat">
                <span class="stat-title">MAX OFF TIME</span>
                <strong class="stat-value">
                  {{ secondsToDDHHMMSS(item.longest_offline_duration) }}</strong>
              </div>
            </div>

            <div class="card-footer">
              <div class="total-time-bar">
                <div class="online-bar" [style.width]="(item.sum_online_time / item.sum_total_seconds * 100) + '%'">
                </div>
              </div>
              <span class="total-time-label">Total Monitored:
                {{ secondsToDDHHMMSS(item.sum_total_seconds) }}</span>
            </div>
          </div>
          }
        </div>
      }
    </div>
  </div>
  @if (isListModalOpen) {
    <app-device-mac-usage-list
      [macAddressClicked] = "macAddressClicked"
      [filterType] = "filterType"
      [startDate] = "startDate"
      [endDate] = "endDate"
      (closeListModal) = "closeListModal($event)"
    ></app-device-mac-usage-list>
  }
</div>
